import * as React from "react";
import {cx} from "emotion";

import "./credit-cards-on-file.scss";

import {CreditCardsLogic}   from "@Common/logic/checkout/credit-cards/credit-cards-logic";
import {isApiTrue}          from "@Common/logic/is-api-true";
import {cs}                 from "@Common/react/chain-services";
import {consumeContext}     from "@Common/react/context";
import {Static2}            from "@Common/react/static-2";
import {ErrorHighlighter}   from "@Common/ui-components/light/error-highlighter";
import {scrollIntoView}     from "@Common/ui-components/light/scroll-into-view";
import {ReCaptchaInvisible} from "@Common/ui-components/recaptcha/recaptcha";

import {CardList}     from "../../../../../common/heavy/credit-cards/card-list/card-list";
import {CardModal}    from "../../../../../common/heavy/credit-cards/card-modal/card-modal";
import {PaymentPanel} from "../common/payment-panel";

import {toCountryCode} from "./to-country-code";

export const CreditCardsOnFile = ({store, remainingAmount, next,}) => cs(
    consumeContext("userLevels"),
    ["logic", ({}, next) => CreditCardsLogic({store, remainingAmount, next})],
    ["recaptcha", ({userLevels}, next) => ReCaptchaInvisible({next, isInternalUser: userLevels?.internalUser})],

    ["eh", (_, next) => ErrorHighlighter({next})],
    ["domRef", (_, next) => Static2({next})],

    ({logic, eh, domRef, recaptcha}) => next({
        highlightErrors: () => {
            eh.start();
            scrollIntoView(domRef.get());
        },

        beforeCheckout: logic.beforeCheckout,
        invalid: logic.errors.length,
        errorMessages: logic.errors,
        selectedCards: logic.summaryCards,
        render: ({className, showErrors}) => cs(
            consumeContext("company"),
            ({company}, next) => !isApiTrue(company?.prefs?.hideCreditCardCollection) ? next() : null,
            ({}) => PaymentPanel({
                title: "Credit Cards on File",
                className: cx(className,eh.css),
                domRef: domRef.set,
                controls: {
                    text: "Charge to multiple cards?",
                    checkbox: {
                        value: logic.multiple.value,
                        onChange: logic.multiple.onToggle,
                        xdQaName: "Charge to multiple cards"
                    },
                },
                content: () => cs(
                    consumeContext("userLevels"),
                    ["cardModal", ({}, next) => CardModal({next})],
                    ({userLevels, cardModal}) => (
                        <div className="credit-cards-on-file-234">
                            {CardList({
                                cards: logic.cards,
                                selectedCards: logic.selectedCards,
                                multiple: logic.multiple.value,
                                onEditNonceCard: async (card) => cardModal.show({
                                    recaptchaToken: (await recaptcha.execute())?.token,
                                    card: {
                                        ...card,
                                        country: toCountryCode(card.country),
                                    },
                                    saveToProfile: false,
                                    isDefaultCard: false,
                                    mode: "edit",
                                    onSave: logic.updateNonceCard,
                                }),
                                onEditSavedCard: async (card) => cardModal.show({
                                    recaptchaToken: (await recaptcha.execute())?.token,
                                    card: {
                                        ...card,
                                        country: toCountryCode(card.country),
                                    },
                                    saveToProfile: true,
                                    isDefaultCard: card.isDefaultCard,
                                    mode: "edit",
                                    onSave: logic.updateSavedCard,
                                }),
                                onDeleteSavedCard: logic.deleteSavedCard,
                                onDeleteNonceCard: logic.deleteNonceCard,
                                getAssumedAmount: logic.getAssumedAmount,
                                onSaveCardAmount: logic.onSaveCardAmount,
                                onDeselectSavedCard: logic.deselectSavedCard,
                                onSelectSavedCard: logic.selectSavedCard,
                            })}

                            <div className="controls">
                                <button
                                    className={cx({disabled: userLevels?.isGuest})}
                                    onClick={async () => {
                                        if(userLevels?.isGuest) {
                                            showErrors.onChange(true);
                                        } else {
                                            cardModal.show({
                                                recaptchaToken: (await recaptcha.execute())?.token,
                                                card: {
                                                    "country" : "US"
                                                },
                                                saveToProfile: true,
                                                isDefaultCard: false,
                                                mode: "add",
                                                onSave: logic.addNewCard,
                                            });
                                        }
                                    }}
                                    xd-qa-type="button"
                                    xd-qa-name="ADD NEW CARD"
                                >
                                    ADD NEW CARD
                                </button>
                            </div>
                        </div>
                    ),
                ),
            }),
        ),
    })
);

